import styled from '@emotion/styled'
import { Tab, Tabs } from '@mui/material'
import APP_BREAKPOINTS, { maxWidth, minWidth } from '../styles/breakpoints'
import { palette } from '../styles/colors'
import { APP_FONT, COMPONENT_HEIGHTS } from '../theme'

export const StyledRoot = styled('div')({
    font: 'inherit',
    flex: '0 0 auto',
    fontSize: '1rem',
    height: COMPONENT_HEIGHTS.tabs,
    marginBottom: 11,
    width: '100%',
    '& header': { backgroundColor: 'inherit' },
})

export const tabsStyles = {
    height: COMPONENT_HEIGHTS.tabs,
    minHeight: COMPONENT_HEIGHTS.tabs,
    maxHeight: COMPONENT_HEIGHTS.tabs,
    '& .MuiTab-wrapper': {
        textTransform: 'none !important' as any,
    },
    '& button.Mui-selected': {
        color: palette.greenLink,
    },
    '& span.MuiTabs-indicator': {
        backgroundColor: palette.greenLink,
    },
    [maxWidth(APP_BREAKPOINTS.sm)]: {
        fontSize: 11,
        '& .MuiTab-root': {
            fontSize: 11,
            padding: 6,
            minWidth: 72,
            maxWidth: 264,
        },
    },
} as const

export const StyledTabs = styled(Tabs)(tabsStyles)

export const tabStyles = {
    fontFamily: APP_FONT,
    textTransform: 'none !important' as any,
    fontWeight: 600,
    fontSize: '0.8125rem',
} as const

export const StyledTab = styled(Tab)({
    ...tabStyles,
    [minWidth(APP_BREAKPOINTS.md)]: {
        width: 160,
    },
})
